export default __webpack_public_path__ + "static/media/element_spec_74.ab374936.jpg";